<template>
  <div>
    <template>
      <div>
        <v-breadcrumbs
          :items="breadcrumb"
          class="px-0 pt-0"
        >
        </v-breadcrumbs>
      </div>
    </template>
    <router-link
      to="/archive-teacher"
      class="text-decoration-none text-subtitle-2 font-weight-bold"
    >
      <v-icon
        color="primary"
        dense
        class="mr-2"
      >
        {{ icons.mdiArrowLeft }}
      </v-icon>
      Kembali
    </router-link>
    <h3 class="my-8">
      Tambah Arsip Soal
    </h3>
    <v-card class="pa-4">
      <v-card-text>
        <div class="mb-4">
          <h4>Soal</h4>
        </div>
        <div>
          <v-textarea
            v-model="archiveQuestion.name"

            :rules="[validation.required]"
            label="Soal"
            outlined
            dense
          >
          </v-textarea>
        </div>

        <div class="mb-4">
          <h4 class="mb-4">
            Masukkan Gambar (jika ada)
          </h4>
          <FileInput
            :value="archiveQuestion.image"
            dense
            outlined
            :disabled="false"
            :prependicon="icons.mdiImageMultipleOutline"
            label="Gambar"
            @input="getFile"
          >
          </FileInput>
        </div>
        <div>
          <v-row>
            <v-col
              cols="12"
              class="py-0"
            >
              <h4 class="mb-5 mt-6">
                Kunci Jawaban
              </h4>
              <v-row>
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  xl="6"
                  class="py-2"
                >
                  <div>
                    <v-text-field
                      v-model="archiveQuestion.choice_a"

                      :rules="[validation.required]"
                      label="Jawaban"
                      outlined
                      dense
                    >
                      <span
                        slot="prepend"
                        class="pt-1"
                      >
                        A.
                      </span>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  xl="6"
                  class="py-2"
                >
                  <div>
                    <v-text-field
                      v-model="archiveQuestion.choice_c"

                      :rules="[validation.required]"
                      label="Jawaban"
                      outlined
                      dense
                    >
                      <span
                        slot="prepend"
                        class="pt-1"
                      >
                        C.
                      </span>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mb-0">
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  xl="6"
                  class="py-2"
                >
                  <div>
                    <v-text-field
                      v-model="archiveQuestion.choice_b"

                      :rules="[validation.required]"
                      label="Jawaban"
                      outlined
                      dense
                    >
                      <span
                        slot="prepend"
                        class="pt-1"
                      >
                        B.
                      </span>
                    </v-text-field>
                  </div>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  lg="6"
                  xl="6"
                  class="py-2"
                >
                  <div>
                    <v-text-field
                      v-model="archiveQuestion.choice_d"

                      :rules="[validation.required]"
                      label="Jawaban"
                      outlined
                      dense
                    >
                      <span
                        slot="prepend"
                        class="pt-1"
                      >
                        D.
                      </span>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col
              cols="12"
              md="6"
              lg="6"
              xl="6"
              class="py-0"
            >
              <h4 class="mb-4">
                Jawaban Yang Benar
              </h4>
              <div class="">
                <v-text-field
                  v-model="archiveQuestion.answer"

                  :rules="[validation.required]"
                  label="Jawaban yang benar"
                  outlined
                  dense
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="6"
              lg="6"
              xl="6"
              class="py-0"
            >
              <h4 class="mb-4">
                Point Jawaban Yang Benar
              </h4>
              <div>
                <v-text-field
                  v-model="archiveQuestion.point"

                  :rules="[validation.required]"
                  label="Point"
                  type="number"
                  outlined
                  dense
                >
                </v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            >
              <h4 class="mb-4">
                Pembahasan
              </h4>
              <div>
                <v-textarea
                  v-model="archiveQuestion.discussion"

                  :rules="[validation.required]"
                  label="Pembahasan"
                  outlined
                  dense
                >
                </v-textarea>
              </div>
            </v-col>
          </v-row>
        </div>
        <div>
          <v-card-actions class="d-flex justify-center mt-10 mb-5">
            <v-btn
              color="primary"
              large
              :loading="isLoadingButton"
              :disabled="!formValidLesson"
              @click="addArchiveQuestion()"
            >
              Simpan
            </v-btn>
            <v-btn
              color="primary"
              outlined
              large
              @click="returnBack"
            >
              Batal
            </v-btn>
          </v-card-actions>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { integerValidator, required } from '@core/utils/validation'
import { mdiArrowLeft, mdiDotsVertical, mdiImageMultipleOutline } from '@mdi/js'
import FileInput from '../../components/FileInput.vue'

// import { ref, watch, onMounted } from '@vue/composition-api'

export default {
  name: 'AddQuestionArchive',
  components: {
    FileInput,
  },
  data() {
    return {
      icons: {
        mdiArrowLeft,
        mdiImageMultipleOutline,
        mdiDotsVertical,
      },
      validation: {
        required,
        integerValidator,
      },
      isLoadingButton: false,
      isDisabledButton: false,
      formValidLesson: false,
      breadcrumb: [
        {
          text: 'Arsip Soal',
          disabled: false,
          href: '/archive-teacher',
        },
        {
          text: 'Tambah Arsip Soal',
          disabled: true,
        },
      ],
      school: [],
      school_uuid: '',
      archiveQuestion: {
        name: '',
        image: null,
        choice_a: '',
        choice_b: '',
        choice_c: '',
        choice_d: '',
        is_essay: '0',
        discussion: '',
        answer: '',
        point: 0,
      },
      teacher: [],
      teacher_uuid: '',
    }
  },
  watch: {
    archiveQuestion: {
      handler() {
        const valid = []
        const requiredField = ['name', 'choice_a', 'choice_b', 'choice_c', 'choice_d', 'answer', 'point', 'discussion']
        Object.entries(this.archiveQuestion).forEach(([key, item]) => {
          if (requiredField.includes(key)) valid.push(!!(item && item.length))
        })
        this.formValidLesson = !valid.includes(false)
      },
      deep: true,
    },
  },
  mounted() {
    this.getTeacher()
  },
  methods: {
    getTeacher() {
      this.teacher = JSON.parse(localStorage.getItem('user')).user.details
      this.teacher.forEach(el => {
        if (el.teacher.uuid === undefined) {
          this.teacher_uuid = el.teacher.uuid

          return
        }
        if (el.teacher.uuid === null) {
          this.showSnackbar({
            text: "You don't have access to teacher",
            color: 'error',
          })

          return
        }
        this.teacher_uuid = el.teacher.uuid
      })

      return true
    },
    returnBack() {
      this.$router.back()
    },
    resetForm() {
      this.archiveQuestion.name = ''
      this.archiveQuestion.image = null
      this.archiveQuestion.choice_a = ''
      this.archiveQuestion.choice_b = ''
      this.archiveQuestion.choice_c = ''
      this.archiveQuestion.choice_d = ''
      this.archiveQuestion.answer = ''
      this.archiveQuestion.point = ''
      this.archiveQuestion.discussion = ''
    },
    getFile(data) {
      this.archiveQuestion.image = data
    },
    getSchoolUuid() {
      this.school = JSON.parse(localStorage.getItem('user')).user.details
      this.school.forEach(el => {
        if (el.school === undefined) {
          this.school_uuid = el.uuid
          this.archiveQuestion.teacher_uuid = el.uuid

          return
        }
        if (el.school === null) {
          this.showSnackbar({
            text: "You don't have access to school",
            color: 'error',
          })

          return
        }
        this.school_uuid = el.school.uuid
        this.archiveQuestion.teacher_uuid = el.teacher.uuid
      })

      return true
    },
    async addArchiveQuestion() {
      this.isLoadingButton = true
      this.isDisabledButton = true
      this.formData = new FormData()
      this.formData.append('teacher_uuid', this.teacher_uuid)
      this.formData.append('name', this.archiveQuestion.name)
      this.formData.append('image', this.archiveQuestion.image)
      this.formData.append('choice_a', this.archiveQuestion.choice_a)
      this.formData.append('choice_b', this.archiveQuestion.choice_b)
      this.formData.append('choice_c', this.archiveQuestion.choice_c)
      this.formData.append('choice_d', this.archiveQuestion.choice_d)
      this.formData.append('answer', this.archiveQuestion.answer)
      this.formData.append('point', this.archiveQuestion.point)
      this.formData.append('discussion', this.archiveQuestion.discussion)
      if (this.archiveQuestion.image === null) {
        this.formData.delete('image')
      }
      await this.$services.ApiServices.add('archivequestion', this.formData).then(
        ({ data }) => {
          this.archiveQuestions = data.data
          this.showSnackbar({
            text: data.result.message,
            color: 'success',
          })
          this.isLoadingButton = false
          this.isDisabledButton = false
        },
        err => {
          this.isDisabledButton = false
          this.isLoadingButton = false
          console.error(err)
        },
      )
      this.returnBack()
      this.resetForm()
    },
    showSnackbar(snackbarData) {
      this.$store.dispatch('snackbar/showSnackbar', snackbarData)
    },
  },
}
</script>

<style scoped>
.app-content-container::v-deep .v-breadcrumbs li {
  font-size: 0.75rem !important;
}
</style>
